import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import { Meta } from '../components/Meta'
import { Community } from '../components/Community'
import { observer } from 'mobx-react-lite'

const CommunityPage = observer((props) => {
  const { data } = props

  return (
    <div key="community-page">
      <Meta {...data.contentfulSiteMetadata.communityPage} />
      <Community {...props} initial={null} />
    </div>
  )
})

export default CommunityPage

export const pageQuery = graphql`
  query CommunityQuery {

    allContentfulSiteGlobalData(filter: { node_locale: { eq: "en-US" } }) {
      edges {
          node {
              v2CommunityContributorsHeading {
                v2CommunityContributorsHeading
              }
              v2CommunityContributorsCopy {
                v2CommunityContributorsCopy
              }

              v2CommunityCollaboratorsHeading {
                v2CommunityCollaboratorsHeading
              }
              v2CommunityCollaboratorsCopy {
                v2CommunityCollaboratorsCopy
              }

              v2CommunityBusinessHeading {
                v2CommunityBusinessHeading
              }
              v2CommunityBusinessCopy {
                v2CommunityBusinessCopy
              }
          }
      }
    }

    contentfulSiteMetadata {
      communityPage {
        description
        image {
          file {
            url
            fileName
          }
          resolutions {
            aspectRatio
          }
        }
        title
        tags
      }
    }
    allContentfulCommunityStatement {
      edges {
        node {
          statement {
            statement
          }
          backgroundImage {
            file {
              url
            }
          }
        }
      }
    }
    allContentfulBusiness(
      sort: {fields: [business], order: ASC}
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          business
          city
          photoCredit
          name
          links {
            label
            link
          }
          industry
          profilePicture {
            file {
              url
            }
            resolutions {
              aspectRatio
            }
          }
        }
      }
    }
    allContentfulContributor(
      sort: {fields: [company], order: DESC}
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          company
          industry
          photoCredit
          links {
            label
            link
          }

          profilePicture {
            file {
              url
            }
            resolutions {
              aspectRatio
            }
          }
        }
      }
    }
    allContentfulCollaborator(
      sort: { fields: orderOfAppearance, order: ASC }
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          company
          role
          teamMembers {
            name
            role
          }
          industry

          links {
            label
            link
          }
          overview {
            internal {
              content
            }
          }
          profilePicture {
            file {
              url
            }
            resolutions {
              aspectRatio
            }
          }
        }
      }
    }
    allContentfulResourceCommunity(
      sort: { fields: orderOfAppearance, order: ASC }
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          resource
          info
          topics {
            label
            link
          }

          profilePicture {
            file {
              url
            }
            resolutions {
              aspectRatio
            }
          }
        }
      }
    }
  }
`
